import "@Styles/Shared/SearchNx/ContentListTemplates/Components/favoriteButton_sm.less";
import "@Styles/Shared/SearchNx/ContentListTemplates/Components/PB/favoriteButton_sm.less";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
//
//
//
//
//
//
//
//
//
import { addFavorite, removeFavorite } from '../../_api';
import { toPascalCase } from '../../_util';
import { FAVORITE_COOKIE_NAME, CURRENT_PAGE_COOKIE_NAME } from '../../_constants';
import { cookie } from '@Shared/Common';
export default {
  props: {
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    item: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    currentPageNumber: {
      type: Number,
      default: function _default() {
        return 0;
      }
    },
    isAnonymous: {
      type: Boolean
    },
    isAnonWithFav: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      settings: this.config ? this.config : {},
      contentItem: this.item ? this.item : {}
    };
  },
  computed: {
    buttonIcon: function buttonIcon() {
      return this.contentItem.isFavorite ? 'iconHeartFilled' : 'iconHeartEmpty';
    },
    buttonText: function buttonText() {
      return this.contentItem.isFavorite ? this.settings.favoritedButtonText : this.settings.defaultButtonText;
    },
    buttonAriaLabel: function buttonAriaLabel() {
      var staticText = this.contentItem.isFavorite ? this.settings.unfavoriteButtonLabel : this.settings.defaultButtonText;
      return staticText + ' ' + this.contentItem.title;
    }
  },
  created: function created() {
    if (this.contentItem.cookieAddFavorite) {
      this.$_addFavorite();
      delete this.contentItem.cookieAddFavorite;
    }

    if (!GeneralMills.PandoSites.ContentList.Favorite) {
      //Temporary Method for AB testing
      GeneralMills.PandoSites.ContentList.Favorite = this.$_favorite;
    }
  },
  methods: {
    buttonClick: function buttonClick() {
      if (this.isAnonymous) {
        cookie.setCookie(FAVORITE_COOKIE_NAME, this.contentItem.id);

        if (this.currentPageNumber > 0) {
          cookie.setCookie(CURRENT_PAGE_COOKIE_NAME, this.currentPageNumber);
        }

        this.$_handleRedirect();
      } else {
        if (!this.contentItem.isFavorite) {
          this.$_addFavorite();
        } else {
          this.$_removeFavorite();
        }
      }
    },
    $_handleRedirect: function $_handleRedirect() {
      var returnUrl = window.location.href;
      var url = this.settings.registrationUrl + '?returnUrl=' + encodeURIComponent(returnUrl) + '&isRegistrationFirstStep=false&RegAction=FAVORITE';

      if (this.isAnonWithFav) {
        url += '&value_prop=AnonFavorites';
      }

      window.location.assign(url);
    },
    $_addFavorite: function $_addFavorite() {
      var _this = this;

      addFavorite(this.contentItem.id).then(function (response) {
        if (response) {
          _this.contentItem.isFavorite = !_this.contentItem.isFavorite;
          GeneralMills.Analytics.raiseEvent({
            EventType: 'AddToFavorites',
            ContentId: _this.contentItem.id,
            ContentTitle: _this.contentItem.title,
            RecordType: toPascalCase(_this.contentItem.contentType),
            ContentType: toPascalCase(_this.contentItem.contentType)
          });
        }
      });
    },
    $_removeFavorite: function $_removeFavorite() {
      var _this2 = this;

      removeFavorite(this.contentItem.id).then(function (response) {
        if (response) {
          _this2.contentItem.isFavorite = !_this2.contentItem.isFavorite;
        }
      });
    },
    //Temporary Method for AB testing
    $_favorite: function () {
      var _$_favorite = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(contentItem, isAddFavorite) {
        var apiCall, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (!this.isAnonymous) {
                  _context.next = 5;
                  break;
                }

                cookie.setCookie(FAVORITE_COOKIE_NAME, contentItem.contentId);
                this.$_handleRedirect();
                return _context.abrupt("return", true);

              case 5:
                apiCall = isAddFavorite ? addFavorite : removeFavorite;
                _context.next = 8;
                return apiCall(contentItem.contentId);

              case 8:
                response = _context.sent;

                if (!response) {
                  _context.next = 12;
                  break;
                }

                if (isAddFavorite) {
                  GeneralMills.Analytics.raiseEvent({
                    EventType: 'AddToFavorites',
                    ContentId: contentItem.contentId,
                    ContentTitle: contentItem.title,
                    RecordType: toPascalCase(contentItem.contentType),
                    ContentType: toPascalCase(contentItem.contentType)
                  });
                }

                return _context.abrupt("return", true);

              case 12:
                return _context.abrupt("return", false);

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](0);
                console.error('Error in $_favorite:', _context.t0);
                return _context.abrupt("return", false);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 15]]);
      }));

      function $_favorite(_x, _x2) {
        return _$_favorite.apply(this, arguments);
      }

      return $_favorite;
    }()
  }
};